import React from 'react';
import { ReactComponent as Icon } from '#web-components/assets/icons/calendar.svg';

export type CalendarIconProps = {
  className?: string,
};

export default function CalendarIcon({ className }: CalendarIconProps) {
  return (
    <Icon className={className} />
  );
}
